export default "__VITE_ASSET__DnfiEpXL__"